import axios from 'axios';

import {API_BASE_URL, API_ENDPOINT_JSON} from '../../../config';
import CRUDMethods from '../../../constants/CRUDConstants';
import {platformJsonFilter} from '../../../pages/orgManager/Utils/OrgProfile/Forms/Constants/Common';
import useJSONStore from '../../../store/StaticJson/jsonStore';
import useUserStore from '../../../store/userStore/userStore';

const OPSubCategory = async (): Promise<any> => {
  const subCategory = useJSONStore.getState().subCategory;
  const token = useUserStore.getState().userToken;
  const setSubCategory = useJSONStore.getState().setSubCategory;

  if (subCategory.length === 0) {
    await axios
      .request({
        method: CRUDMethods.GET,
        url: `${API_BASE_URL}${API_ENDPOINT_JSON.JSON.subCategory}`,
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {},
        data: {}
      })
      .then((res) => {
        setSubCategory(platformJsonFilter(res.data.data));
      })
      .catch((err) => {
        return err.message;
      });
  }
};

export default OPSubCategory;
